export const initialState = {
    searchTerm: '',
    page: 1,
    subPage: 1,
    startDate: null,
    endDate: null,
    sortOrder: null,
    sortBy: null,
    subjectType: null,
    subject: null,
    audit: null,
    itemTypeAction: null,
    participantType: [],
    approvalDecision: null,
    requestedBy: null,
    approver: null,
    approverType: 'current',
    showOnlyWhereNoApprovers: null,
    showOnlyPreApproved: false,
    wentForApproval: true,
    status: [],
    approverDecisionItemStatus: [],
    approverDecisionStepStatus: [],
    approverDecisionRiskType: [],
    fulfillmentStatus: null,
    itemType: [],
    riskLevels: [],
    businessRequestType: null,
    dateFilterType: 'Initiated',
    initiatedBy: null,
    accessAssignee: null,
}

const reducer = (state, { type, payload }) => {
    switch (type) {
        case 'SET_PROP':
            return {
                ...state,
                page: 1,
                [payload.key]: payload.value,
            }
        case 'SET_MULTIPLE_PROPS':
            return {
                ...state,
                page: 1,
                ...payload,
            }

        case 'SET_PAGE':
            return {
                ...state,
                page: payload,
            }
        case 'SET_SUBPAGE':
            return {
                ...state,
                subPage: payload,
            }
        case 'SET_BUSINESS_REQUEST_TYPE':
            return {
                ...state,
                page: 1,
                businessRequestType: payload.businessRequestType,
            }

        default:
            return state
    }
}

export default reducer
